import { isObject } from "../../common/util.js";

const questionObj = {
    all: "",
    initQues: "first_ask",
    input: "input",
    click: "click",
};

// 赞踩数据总览服务端数据转换
function queryLikeStatistic2Server(reqData) {
    const request = {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        set_id: reqData.setId,
        channel: reqData.channel === "all" ? "" : reqData.channel,
        question_type: questionObj[reqData.questionType] || "",
        language: reqData.language === "all" ? "" : reqData.language,
    };
    Object.keys(request).forEach(item => {
        if (request[item] === undefined || request[item] === null || request[item] === "") {
            delete request[item];
        }
    })
    return request;
};

// 赞踩数据总览客户端数据转换
function queryLikeStatistic2Client(result) {
    const data = {
        feedback: {
            num: result.feedback_num || 0,
            user: result.feedback_user,
            rate: result.feedback_rate_print,
        },
        like: {
            num: result.like_num || 0,
            rate: result.like_rate_print,
        },
        question: {
            num: result.question_num || 0,
            user: result.question_user,
        }
    }
    return data;
};

// 
function queryLikeQuestion2Server(reqData) {
    const sortTypeMap = {
        descending: "desc",
        ascending: "asc",
    };
    const sortFieldMap = {
        feedbackNum: "feedback_num",
        feedbackRatePrint: "feedback_rate",
        likeRatePrint: "like_rate",
        evaluateIrrelevant: "evaluate_irrelevant",
        evaluateDissatisfactionNum: "evaluate_dissatisfaction_num",
        evaluateUnresolved: "evaluate_unresolved",
        evaluateCustomized: "evaluate_customized",
    };

    const request = {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        set_id: reqData.setId,
        channel: reqData.channel === "all" ? "" : reqData.channel,
        question_type: questionObj[reqData.questionType] || "",
        language: reqData.language === "all" ? "" : reqData.language,
        page: reqData.page,
        size: reqData.size,
        sort_field: reqData.sortField ? sortFieldMap[reqData.sortField] : "",
        sort_type: reqData.sortType ? sortTypeMap[reqData.sortType] : "",
    };
    return request;
};

// 【全部FAQ问题】赞踩列表客户端数据转换
function queryLikeQuestionList2Client(result) {
    const { count, list = [] } = result;
    return {
        count,
        list: list.map(item => ({
            feedbackNum: item.feedback_num,
            feedbackRatePrint: item.feedback_rate_print,
            likeRatePrint: item.like_rate_print,
            evaluateDissatisfactionNum: item.evaluate_dissatisfaction_num,
            evaluateIrrelevant: item.evaluate_irrelevant,
            evaluateUnresolved: item.evaluate_unresolved,
            evaluateCustomized: item.evaluate_customized,
            sgameid: item.sgameid,
            questionId: item.question_id,
            question: item.question,
        }))
    };
};

// 【全部子场景】赞踩列表客户端数据转换
function queryLikeQuestionSet2Client(result) {
    const { count, list = [] } = result;
    return {
        count,
        list: list.map(item => ({
            feedbackNum: String(item.feedback_num),
            feedbackRatePrint: item.feedback_rate_print,
            likeRatePrint: item.like_rate_print,
            evaluateDissatisfactionNum: String(item.evaluate_dissatisfaction_num),
            evaluateIrrelevant: String(item.evaluate_irrelevant),
            evaluateUnresolved: String(item.evaluate_unresolved),
            evaluateCustomized: String(item.evaluate_customized),
            setId: item.set_id,
            setLevel: item.set_level,
            setName: item.set_name,
        }))
    }
};

// 去除字符串的百分号
function removePercentSign(str) {
    return str.substring(0, str.length - 1);
};

// 满意度趋势图数据转换
function transSatisfactionTrend(result) {
    let ret = {
        xAxisData: [],
        likeRatePrint: [],
        feedbackRatePrint: [],
    };
    if (isObject(result)) {
        const arr = Object.keys(result);
        for (let i = 0; i < arr.length; i++) {
            const item = result[arr[i]];
            ret.xAxisData.push(item.idate);
            ret.feedbackRatePrint.push(removePercentSign(item.feedback_rate_print));
            ret.likeRatePrint.push(removePercentSign(item.like_rate_print));
        }
    }
    return ret;
};

// 点踩原因柱形图数据转换
function transDislikeHistogram(result) {
    let ret = {
        xAxisData: [],
        dislikeOne: [],
        dislikeTwo: [],
        dislikeThree: [],
        dislikeOther: [],
    };
    if (isObject(result)) {
        const arr = Object.keys(result);
        for (let i = 0; i < arr.length; i++) {
            const item = result[arr[i]];

            ret.xAxisData.push(item.idate);
            ret.dislikeOne.push(removePercentSign(item.evaluate_dissatisfaction_rate_print));
            ret.dislikeTwo.push(removePercentSign(item.evaluate_irrelevant_rate_print));
            ret.dislikeThree.push(removePercentSign(item.evaluate_unresolved_rate_print));
            ret.dislikeOther.push(removePercentSign(item.evaluate_customized_rate_print));
        }
    }
    return ret;
};


export default {
    queryLikeStatistic2Server,
    queryLikeStatistic2Client,
    queryLikeQuestion2Server,
    queryLikeQuestionList2Client,
    queryLikeQuestionSet2Client,
    transSatisfactionTrend,
    transDislikeHistogram,
};

